export {
    embedCreateRequestRoute,
    embedSinglePortalRoute,
    embedKBArticleRoute,
    embedFeaturedPortalsRoute,
} from './routes';
